export default {
  form: {
    font_family: {
      label: 'Familia tipográfica',
    },
    header: {
      label: 'Encabezado',
      placeholder: 'Encabezado',
    },
    sub_header: {
      label: 'Subencabezado',
      placeholder: 'Subencabezado',
    },
    footer: {
      label: 'Texto del pie',
      placeholder: 'Introduce el texto del pie',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Seleccionar URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Color primario',
    },
    background_color: {
      label: 'Color de fondo',
    },
    cover_image: {
      label: 'Imagen de portada',
    },
    logo: {
      label: 'Logotipo',
    },
    logo_zoom: {
      label: 'Zoom del logotipo',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar el adhesivo de puerta',
  },
};
